export default __webpack_public_path__ + "static/media/gusto.71836dd7.svg";